import {
  SminexClubClientsByEventParticipant,
  SminexClubClientsByEventPayload,
  SminexClubClientsByEventTicket,
} from './subscription';
import { SminexClubWsClient } from './types';
import { concatArray } from '@shared/lib';

const normalizeInvitation = (value: string | null | undefined): string => {
  if (!value) return '';
  return value.toUpperCase();
};

const mapProjects = (projects: SminexClubClientsByEventParticipant['projects']): string[] => {
  if (!Array.isArray(projects)) return [];

  return projects.filter((name): name is string => typeof name === 'string' && !!name.trim());
};

const mapTicket = (ticket: SminexClubClientsByEventTicket, manager?: string | null) => {
  const invitedByManager = ticket.invitedByManager ?? null;

  return {
    id: ticket.id ?? 0,
    checked: Boolean(ticket.checked),
    checkInTime: ticket.checkInTime ?? null,
    scanType: ticket.scanType ?? null,
    organizerName: ticket.organizerName ?? '',
    sminexClubInvitation: normalizeInvitation(ticket.sminexClubInvitation),
    sminexClubReconfirmationStatus: normalizeInvitation(ticket.sminexClubReconfirmationStatus),
    review: ticket.review ?? '',
    comment: ticket.comment ?? null,
    sminexClubAdditional:
      ticket?.dependents?.adult.map(({ id, participant, checked }) => ({
        id: id,
        fio: concatArray([participant.lastName, participant.firstName, participant.surname]),
        checked,
      })) || [],
    invitedByManager: invitedByManager ?? manager ?? null,
    mobileComment: ticket.mobileComment || '',
  };
};

export const mapSminexClubClientsByEventPayload = (payload?: SminexClubClientsByEventPayload) => {
  const rows = payload?.getSminexClubClients?.data;

  if (!Array.isArray(rows)) return;

  const clients: SminexClubWsClient[] = [];

  rows.forEach((row) => {
    const participant = row?.participant;
    if (!participant) return;

    clients.push({
      participantId: participant.tickets?.participant?.id ?? null,
      crmUuid: participant.crmUuid ?? '',
      firstName: participant.firstName ?? '',
      lastName: participant.lastName ?? '',
      surname: participant.surname ?? null,
      projects: mapProjects(participant.projects),
      manager: participant.manager ?? null,
      broker: participant.broker ?? null,
      callRefusal: participant.callRefusal ?? null,
      isSpecial: !!participant.tickets.isSpecial,
      ticket: mapTicket(participant.tickets, participant.manager),
    });
  });

  return clients;
};
